var Ribbon_default = {
  "ribbon": "c4Ylb",
  "ribbonText": "M5fKe",
  "imageRibbon": "rOcR4"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
